module.exports = __webpack_public_path__ + "static/media/grass02.74750f16.png";